type EventQueryInvalidators = {
  events: {
    publicCatalog: { invalidate: () => Promise<unknown> };
    managedEvents: { invalidate: () => Promise<unknown> };
    adminRegistrationCounts: { invalidate: () => Promise<unknown> };
    ticketQuote: { invalidate: (input: { slug: string }) => Promise<unknown> };
  };
};

/** Cache refreshes happen only after the webhook-issued ticket list is complete. */
export function invalidateConfirmedTicketCache(
  utils: EventQueryInvalidators,
  eventSlugs: string[],
  authenticatedViewer: boolean,
): Promise<unknown[]> {
  const tasks: Promise<unknown>[] = [
    utils.events.publicCatalog.invalidate(),
    ...Array.from(new Set(eventSlugs), slug => utils.events.ticketQuote.invalidate({ slug })),
  ];
  // These procedures are administrator/member-only: never invalidate them from
  // the account-free guest ticket portal.
  if (authenticatedViewer) {
    tasks.push(
      utils.events.managedEvents.invalidate(),
      utils.events.adminRegistrationCounts.invalidate(),
    );
  }
  return Promise.all(tasks);
}
